import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { GetResultDiagnosisApiResponse, IDAssessmentListApi, IDDiagnosisApi, getAssessmentCodeResultResponse } from 'models/DCK/DCKApiTypes';

class AssessmentApi {
    async getResultDiagnosis(url: string, token: string): Promise<GetResultDiagnosisApiResponse> {
        try {
            const response = await axios.get(apiPaths.getResultDiagnosis + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getAssessmentCodeResult(url: string, token: string): Promise<getAssessmentCodeResultResponse> {
        try {
            const response = await axios.get(apiPaths.findByCode + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getAssessmentList(token: string): Promise<IDAssessmentListApi> {
        try {
            const response = await axios.get(apiPaths.getAssessmentList, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async addAssessment(rqData: { _id: string; codeList: string[] }, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.put(apiPaths.assignAssessment, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const DCKAssessmentApi = new AssessmentApi();
